import { useMemo } from 'react';
import { TariffTypeVerification } from '@src/core/buyerApiClient';

/**
 * Hook to generate the field key for tariff verification
 */
export const useFieldKey = (tariffTypeVerification: TariffTypeVerification, tariffIndex: number): string => {
  return useMemo(
    () => `${tariffTypeVerification.tariffVerificationId}[${tariffIndex}]`,
    [tariffTypeVerification.tariffVerificationId, tariffIndex],
  );
};
